import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Form, Checkbox, Header, Icon, Segment } from "semantic-ui-react";

class TyreMotionConfiguration extends Component {
  handleCheckboxChange = (_e, { name, checked }) => {
    const { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked });
  };

  render() {
    const { location, t } = this.props;

    return (
      <Segment>
        <Header as="h5">
          <Icon name="settings" />
          <Header.Content>{t("tyre_motion_ai").message || "Tyre Motion AI"}</Header.Content>
        </Header>

        <Form>
          <Form.Field>
            <Checkbox
              checked={location.is_tyre_motion_enabled}
              name="is_tyre_motion_enabled"
              label={t("scan_tyre_data").message || "Scan tyre data"}
              onChange={this.handleCheckboxChange}
            />
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

export default withTranslation()(TyreMotionConfiguration);
